<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Giacenze Magazzino</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="infoDlg = true"
            >
              <v-icon color="#2196f3"> mdi-information </v-icon>
            </v-btn>
          </template>
          <span>Informazioni</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="vistaSintetica"
            >
              <v-icon color="#2196f3"> mdi-table </v-icon>
            </v-btn>
          </template>
          <span>Analisi sintetica</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="vistaDettagliata"
              class="mr-5"
            >
              <v-icon color="#2196f3"> mdi-table-search </v-icon>
            </v-btn>
          </template>
          <span>Analisi dettagliata</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="$router.push({ name: 'home-magazzino' })"
            >
              <v-icon color="#2196f3"> mdi-warehouse </v-icon>
            </v-btn>
          </template>
          <span>Anagrafica Magazzini</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="clickImpegnaSuProgetto"
            >
              <v-icon color="#2196f3"> mdi-dolly </v-icon>
            </v-btn>
          </template>
          <span>Impegna Articolo su Progetto</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="clickGestisciImpegniGenerali"
            >
              <v-icon color="#2196f3"> mdi-target </v-icon>
            </v-btn>
          </template>
          <span>Gestisci Impegni su Progetti</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="
                $router.push({
                  name: 'trasferimenti-magazzino',
                  params: { id: id_articolo_sel },
                })
              "
            >
              <v-icon color="#2196f3"> mdi-arrow-right-bold-box </v-icon>
            </v-btn>
          </template>
          <span>Trasferisci Articoli</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              class="mr-5"
              @click="nuovoMovimento"
            >
              <v-icon color="#2196f3"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Nuovo Movimento</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="gestisci_ricerca_visible = true"
              v-on="on"
              small
              elevation="1"
              v-show="id_profilo == 1"
            >
              <v-icon color="primary"> mdi-filter-cog </v-icon>
            </v-btn>
          </template>
          <span>Gestisci Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="toggleFilters"
              class="mr-5"
            >
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="cancellaFiltri"
              class="mr-5"
            >
              <v-icon color="error"> mdi-filter-off </v-icon>
            </v-btn>
          </template>
          <span>Cancella Tutti i Filtri</span>
        </v-tooltip>
        <v-autocomplete
          dense
          hide-details
          :items="items_ricerche_selezionabili"
          item-text="des_ricerca"
          item-value="id_ricerca"
          label="Filtro Personalizzato"
          outlined
          style="background-color: white; border-radius: 10px; max-width: 200px"
          v-model="filtro_selezionato"
          v-show="items_ricerche_selezionabili.length > 0"
        >
          <template v-slot:append>
            <v-icon
              @click="filtro_selezionato = null"
              color="error"
              v-if="filtro_selezionato != null"
            >
              mdi-close
            </v-icon>
          </template>
        </v-autocomplete>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.push({ name: 'Production Dashboard' })"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-card-text>
        <v-col v-if="show_filters && filtro_selezionato == null">
          <v-row dense>
            <v-col dense>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    @keyup.enter="searchByCodDesArticolo()"
                    label="Cod. Articolo"
                    dense
                    hide-details
                    outlined
                    clearable
                    v-model="codice_articolo"
                    @input="filtro_des_articolo = null"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        small
                        elevation="1"
                        @click="searchByCodDesArticolo"
                      >
                        <v-icon color="#1a80b6">mdi-magnify</v-icon>
                      </v-btn>

                      <v-btn
                        small
                        class="ml-2"
                        elevation="1"
                        @click="searchByCodiceParziale"
                      >
                        <v-icon color="#1a80b6">
                          mdi-magnify-plus-outline
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <span>
                  Si puo cercare un codice parziale usando un asterisco
                </span>
              </v-tooltip>
            </v-col>

            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    @keyup.enter="searchByCodDesArticolo()"
                    label="Des. Articolo"
                    dense
                    hide-details
                    outlined
                    clearable
                    v-model="filtro_des_articolo"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        small
                        class="mr-2"
                        elevation="1"
                        @click="searchByCodDesArticolo"
                      >
                        <v-icon color="#1a80b6">mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <span>
                  Si puo cercare una descrizione parziale usando un asterisco
                </span>
              </v-tooltip>
            </v-col>

            <v-col>
              <v-text-field
                label="Cod. Lotto"
                dense
                hide-details
                outlined
                clearable
                v-model="codice_lotto"
              >
                <template v-slot:append-outer>
                  <v-btn small elevation="1" @click="searchByCodiceLotto">
                    <v-icon color="#1a80b6">mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>

            <!--ricerca ubicazione-->
            <v-col dense>
              <v-text-field
                label="Ubicazione"
                dense
                hide-details
                outlined
                clearable
                v-model="codUbicazione"
              >
                <template v-slot:append-outer>
                  <v-btn small elevation="1" @click="searchCodUbicazione">
                    <v-icon color="#1a80b6">mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                label="Seriale"
                dense
                hide-details
                outlined
                clearable
                v-model="seriale"
              >
                <template v-slot:append-outer>
                  <v-btn
                    small
                    class="mr-2"
                    elevation="1"
                    @click="searchBySeriale"
                  >
                    <v-icon color="#1a80b6">mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-menu
                ref="menu-da"
                v-model="menu_da"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    append-icon="mdi-close"
                    @click:append="clearStart"
                    dense
                    hide-details
                    v-model="data_start_formatted"
                    label="Da"
                    autocomplete="off"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @change="changeDate"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="data_start"
                  no-title
                  locale="it"
                  @input="changeDate"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                ref="menu-a"
                v-model="menu_a"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    append-icon="mdi-close"
                    @click:append="clearEnd"
                    dense
                    hide-details
                    v-model="data_end_formatted"
                    label="A"
                    autocomplete="off"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    @change="changeDate"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        small
                        class="mr-2"
                        elevation="1"
                        @click="searchByDate"
                      >
                        <v-icon color="#1a80b6">mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="data_end"
                  no-title
                  locale="it"
                  @input="changeDate"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-select
                label="Sede"
                dense
                outlined
                hide-details
                v-model="sede"
                :items="sedi"
                item-text="sede_magazzino"
                item-value="sede_magazzino"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-autocomplete
                clearable
                dense
                hide-details
                :items="giacenze_magazzino_backup"
                item-text="des_magazzino"
                item-value="des_magazzino"
                label="Des. Magazzino"
                outlined
                v-model="descrizione_magazzino"
              >
                <template v-slot:append-outer>
                  <v-btn
                    small
                    class="mr-2"
                    elevation="1"
                    @click="searchAllInMagazzino"
                  >
                    <v-icon color="#1a80b6">mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                clearable
                dense
                outlined
                hide-details
                :items="giacenze_magazzino_backup"
                item-text="cod_des_magazzino"
                item-value="cod_magazzino"
                label="Codice Magazzino"
                v-model="codice_magazzino"
              >
                <template v-slot:append-outer>
                  <v-btn
                    small
                    class="mr-2"
                    elevation="1"
                    @click="searchAllInMagazzino"
                  >
                    <v-icon color="#1a80b6">mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else-if="show_filters && filtro_selezionato != null">
          <InputRicerca
            @applica_filtri="applicaFiltri"
            :id_session_key="id_utente + 'giacenze_magazzino_key'"
            :lista_filtri="[ricerca_sel]"
            :key="filtro_selezionato"
          />
        </v-col>

        <v-row>
          <v-col>
            <v-data-table
              fixed-header
              :headers="headers"
              :items="lista_tabella"
              item-key="index"
              show-expand
              :expanded.sync="expandedIds"
              :key="tableKey"
              height="70vh"
            >
              <template v-slot:[`item.movimenti`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="redirectToMagazzinoMovimenti(item)"
                    >
                      <v-icon color="#1a80b6">mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Lista Movimenti</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.cod_articolo`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="
                        codice_articolo = item.cod_articolo;
                        searchByCodDesArticolo();
                      "
                    >
                      {{ item.cod_articolo }}
                    </v-btn>
                  </template>
                  <span>Cerca per questo codice articolo</span>
                </v-tooltip>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="pa-0"
                  style="background-color: white"
                >
                  <v-data-table
                    :headers="subHeaders"
                    :items="
                      item.lotti?.filter((e) => {
                        return (
                          e.date_ins == null ||
                          ((data_end == null || e.date_ins < data_end) &&
                            (data_start == null || e.date_ins > data_start))
                        );
                      })
                    "
                    hide-default-footer
                    class="elevation-1"
                  >
                    <template v-slot:[`item.ristampa`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            small
                            elevation="1"
                            @click="RistampaReport(item)"
                          >
                            <v-icon color="primary">mdi-printer</v-icon>
                          </v-btn>
                        </template>
                        <span>Ristampa Report</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.id_controllo`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :color="
                              item.id_controllo == 0 ? 'error' : 'success'
                            "
                            >{{
                              item.id_controllo == 0 ? "mdi-close" : "mdi-check"
                            }}</v-icon
                          >
                        </template>
                        <span>{{
                          item.id_controllo == 0
                            ? "Non Confermato"
                            : "Confermato"
                        }}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.cod_lotto`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            small
                            elevation="1"
                            @click="
                              codice_lotto = item.cod_lotto;
                              searchByCodiceLotto();
                            "
                          >
                            {{ item.cod_lotto }}
                          </v-btn>
                        </template>
                        <span>Cerca per questo codice lotto</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.numero_seriale`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            small
                            elevation="1"
                            @click="
                              seriale = item.numero_seriale;
                              searchBySeriale();
                            "
                          >
                            {{ item.numero_seriale }}
                          </v-btn>
                        </template>
                        <span>Cerca per questo seriale</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      persistent
      v-model="movimentoDialog"
      width="800"
      :retain-focus="false"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Nuovo Movimento</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaMovimento" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva Movimento</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiMovimentoDialog"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-card-text class="red--text" v-if="qntError">
                Quantità disponibile insufficente per eseguire movimento
              </v-card-text>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                readonly
                dense
                outlined
                label="Codice Articolo"
                v-model="tempArticolo.cod_articolo"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                append-icon="mdi-magnify"
                readonly
                @keydown.enter="movimentoSelectUbicazione"
                @click:append="movimentoSelectUbicazione"
                dense
                outlined
                label="Ubicazione"
                v-model="tempUbicazione.des_dettaglio"
              >
                <!--<template v-slot:item="data">
                    <v-list-item-content
                        v-if="data.item.quantita != null"
                        class="green--text font-weight-bold"
                        v-text="data.item.des_dettaglio">
                    </v-list-item-content>
                    <v-list-item-content
                        v-else
                        class="yellow--text font-weight-bold"
                        v-text="data.item.des_dettaglio">
                    </v-list-item-content>
                </template>-->
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                readonly
                label="Quantita Disponibile"
                v-model="tempUbicazione.quantita_att"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="9">
              <v-text-field
                dense
                outlined
                readonly
                label="Descrizione Articolo"
                v-model="tempArticolo.des_articolo"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                dense
                outlined
                readonly
                label="Peso (Kg)"
                v-model="tempArticolo.peso_netto"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col clos="3">
              <v-text-field
                dense
                outlined
                label="Quantita"
                type="number"
                v-model="tempMovimento.quantita"
              >
              </v-text-field>
            </v-col>
            <v-col clos="3">
              <v-text-field
                dense
                outlined
                @keydown.enter="editLottoNuovoMovimento"
                label="Lotto"
                readonly
                v-model="tempMovimento.cod_lotto"
              >
                <template v-slot:append>
                  <v-btn @click="editLottoNuovoMovimento" icon small>
                    <v-icon color="primary"> mdi-pencil </v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
            <v-col clos="3">
              <v-text-field
                dense
                outlined
                label="Data Scadenza"
                readonly
                v-model="data_nuovo_lotto_formattata"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                dense
                outlined
                label="Seriale"
                v-model="tempMovimento.numero_seriale"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-select
                dense
                outlined
                label="Causale"
                :items="causali"
                item-text="des"
                item-value="id_tabella"
                v-model="tempMovimento.id_causale"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-textarea
                dense
                outlined
                label="Note"
                v-model="tempMovimento.note"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="infoDlg" width="400">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Informazioni</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="infoDlg = false" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="body-1">
          Si puo cercare per un codice articolo parziale usando un asterisco.
          Per esempio: ART*
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="ubicazioneDialog" width="400">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Ubicazione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="updateUbicazione" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Seleziona</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="ubicazioneDialog = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>

        <v-col>
          <v-autocomplete
            :items="magazzini"
            @change="getStruttura"
            item-text="des_magazzino"
            v-model="selMagazzino"
            return-object
            label="magazzino"
            dense
            outlined
          >
          </v-autocomplete>
          <v-card flat max-height="60vh" class="overflow-y-auto">
            <v-treeview :items="ubicazioneTree" return-object item-key="name">
              <template v-slot:append="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      v-if="item.children == null"
                      class="mr-2"
                      small
                      elevation="1"
                      @click="selectItem(item)"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Seleziona</span>
                </v-tooltip>
              </template>
            </v-treeview>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_multiscelta" width="80vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Articoli</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiMultiscelta" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-2" style="overflow-y: auto">
          <v-data-table
            fixed-header
            :headers="headers_articoli"
            max-height="70vh"
            :items="items_articoli"
          >
            <template v-slot:[`item.modifica`]="{ item }">
              <v-btn @click="clickScegliArticolo(item)" small>
                <v-icon color="success">mdi-check</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="pdfdialog" width="unset" content-class="pdfdialog">
      <v-card>
        <v-toolbar
          class="white--text"
          color="blue"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-toolbar-title> Stampa Pdf </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="red--text"
            @click="pdfdialog = false"
            color="blue-grey lighten-5"
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row>
          <v-col cols="12" sm="6" md="12">
            <iframe
              :src="selected_pdf"
              frameborder="0"
              style="height: 90vh !important; width: 90vw !important"
            >
            </iframe>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Finestra di dialogo per inserire un 
         nuovo lotto o sceglierne uno vecchio. -->
    <v-dialog
      v-model="dialog_lotto_nuovo_movimento"
      width="800px"
      :retain-focus="false"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Lotti Disponibili
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Pulsante per aggiunta lotto totalmente nuovo -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickAggiungiLotto" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Pulsante di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_lotto_nuovo_movimento = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container fluid>
            <v-row align="center" justify="center" dense>
              <v-col class="py-0" cols="6">
                <v-autocomplete
                  @change="filtraLotti"
                  dense
                  :items="items_lotti_nuovo_movimento_visualizzati"
                  item-text="cod_lotto"
                  item-value="cod_lotto"
                  label="Filtro Lotti"
                  outlined
                  style="border-radius: 0px"
                  v-model="filter_cod_lotto"
                >
                  <template v-slot:append>
                    <v-btn
                      icon
                      @click="
                        filter_cod_lotto = '';
                        filtraLotti();
                      "
                      small
                    >
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="py-0" cols="6"></v-col>
            </v-row>
            <v-row align="center" justify="center" dense>
              <v-col class="py-0" cols="12">
                <v-data-table
                  dense
                  :items="items_lotti_nuovo_movimento_visualizzati"
                  :headers="headers_lotti_nuovo_movimento"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn @click="selezionaLotto(item)" small>
                      <v-icon color="primary"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Finestra di dialogo per il dettaglio 
         del nuovo lotto da aggiungere. -->
    <v-dialog v-model="dialog_add_lotto" width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Nuovo Lotto </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Pulsante di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiLotto" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Pulsante di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_add_lotto = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-container fluid>
            <v-row>
              <!-- Input readonly del codice articolo -->
              <v-col cols="4">
                <v-text-field
                  dense
                  hide-details
                  label="Codice Articolo"
                  outlined
                  readonly
                  v-model="tempArticolo.cod_articolo"
                ></v-text-field>
              </v-col>

              <!-- Input del codice lotto -->
              <v-col cols="4">
                <v-text-field
                  dense
                  hide-details
                  label="Codice Lotto"
                  outlined
                  v-model="nuovo_lotto.cod_lotto"
                ></v-text-field>
              </v-col>

              <!-- Input della data scadenza -->
              <v-col cols="4">
                <v-menu
                  v-model="calendario_data_nuovo_lotto"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data Scadenza"
                      outlined
                      v-model="data_nuovo_lotto_formattata"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nuovo_lotto.data_scadenza"
                    @input="calendario_data_nuovo_lotto = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog per impegnare l'articolo su un progetto. -->
    <v-dialog v-model="impegni_progetto_visible" width="75vw">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="my-n1 mr-2 pa-0"
            @chiudi="impegni_progetto_visible = false"
            @impegni_salvati="handleImpegniSalvati"
            :component="'contabilita'"
            ref="windowframe"
            :input_args="input_args"
            :key="key_impegno_articolo"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog per impegnare su qualsiasi progetto qualsiasi articolo. -->
    <v-dialog v-model="impegni_totali_progetto" width="75vw">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="my-n1 mr-2 pa-0"
            @click_chiudi_impegni_generali="impegni_totali_progetto = false"
            :component="'contabilita'"
            ref="windowframe"
            :input_args="input_args"
            :key="key_impegni_generali"
          />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_selezione_progetti" width="700px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Progetti </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_selezione_progetti = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                label="Cod. Progetto"
                v-model="filtro_progetti_cod"
                dense
                hide-details
                :items="items_progetti_visualizzati"
                item-value="codice"
                item-text="codice"
              >
                <template v-slot:append>
                  <v-icon
                    color="error"
                    @click="
                      filtro_progetti_des = null;
                      filtro_progetti_cod = null;
                      filtraProgetti();
                    "
                    v-if="filtro_progetti_cod !== null"
                  >
                    mdi-close
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                label="Des. Progetto"
                v-model="filtro_progetti_des"
                dense
                hide-details
                :items="items_progetti_visualizzati"
                item-value="des_progetto"
                item-text="des_progetto"
              >
                <template v-slot:append>
                  <v-icon
                    color="error"
                    @click="
                      filtro_progetti_des = null;
                      filtro_progetti_cod = null;
                      filtraProgetti();
                    "
                    v-if="filtro_progetti_des !== null"
                  >
                    mdi-close
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                height="70vh"
                :headers="headers_progetti"
                :items="items_progetti_visualizzati"
              >
                <template v-slot:[`item.seleziona`]="{ item }">
                  <v-btn @click="selezionaProgetto(item)" small>
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Finestra di dialogo per impostare i filtri -->
    <v-dialog persistent v-model="gestisci_ricerca_visible" width="unset">
      <GestioneRicerca
        @click_chiudi="gestisci_ricerca_visible = false"
        :modulo="modulo"
        :stringa_modello="stringa_modello"
        @update_filtri="getRicerche"
        v-if="gestisci_ricerca_visible"
      />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="loading" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import GestioneRicerca from "@/components/TOOLS/GestioneRicerca/GestioneRicerca.vue";
import InputRicerca from "@/components/TOOLS/GestioneRicerca/InputRicerca.vue";
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "GiacenzeMagazzino",
  components: {
    GestioneRicerca,
    InputRicerca,
    SnackbarQV,
    WindowFrame,
  },
  data() {
    return {
      // Variabili di supporto
      articolo_gestione_lotti: 0,
      codice_articolo: null,
      codice_lotto: null,
      codice_magazzino: null,
      codUbicazione: "",
      data_end: null,
      data_start: null,
      data_start_formatted: null,
      data_end_formatted: null,
      descrizione_magazzino: null,
      filter_cod_lotto: "",
      filtro_des_articolo: null,
      filtro_progetti_cod: null,
      filtro_progetti_des: null,
      filtro_selezionato: null,
      id_articolo_sel: null,
      input_args: {
        id_articolo: null,
        id_progetto: null,
        landing_page: "/impegni",
        show_toolbar: false,
        tipo_associazione: "progetti",
      },
      id_profilo: null,
      id_utente: null,
      modulo: "GIACENZE_MAGAZZINO",
      nuovo_lotto: { cod_lotto: "", data_scadenza: "" },
      qntError: false,
      qntFinal: 0,
      ricerca_sel: {
        des_ricerca: "Default",
        query: "",
        id_ricerca: this.filtro_selezionato,
        filtri_dettaglio: [],
      },
      show_filters: true,
      searchUbicazione: {},
      sede: null,
      selMagazzino: null,
      selected_pdf: null,
      selUbicazione: null,
      selUbicazioneid: null,
      stringa_modello:
        "id_articolo\n" +
        "cod_articolo\n" +
        "des_articolo\n" +
        "id_magazzino\n" +
        "cod_magazzino\n" +
        "des_magazzino\n" +
        "sede_magazzino\n" +
        "cod_lotto\n" +
        "ubicazione\n" +
        "seriale\n" +
        "id_controllo\n" +
        "giacenza\n" +
        "data_da (una sola uguale per tutti)\n" +
        "data_a (una sola uguale per tutti)\n" +
        "id_um\n" +
        "des_um",
      seriale: "",
      tableKey: 0,
      tempArticolo: {},
      tempMovimento: {
        id_magazzino_movimenti: -1,
        id_magazzino: 0,
        id_ubicazione: 0,
        id_articolo: 0,
        cod_articolo: "",
        des_articolo: "",
        id_lotto: 0,
        cod_lotto: "",
        numero_seriale: "",
        quantita: 0,
        id_causale: null,
        id_causale_magazzino: 1,
        des_causale_magazzino: "",
        data_scadenza_lotto: "",
      },
      tempUbicazione: {},
      ubicazioneSelectMode: 0,

      // Modal
      calendario_data_nuovo_lotto: false,
      dialog_add_lotto: false,
      dialog_lotto_nuovo_movimento: false,
      dialog_multiscelta: false,
      dialog_selezione_progetti: false,
      gestisci_ricerca_visible: false,
      impegni_progetto_visible: false,
      impegni_totali_progetto: false,
      infoDlg: false,
      key_impegno_articolo: 0,
      key_impegni_generali: 0,
      loading: false,
      menu_a: false,
      menu_da: false,
      movimentoDialog: false,
      pdfdialog: false,
      ubicazioneDialog: false,

      // Array
      articoli: [],
      causali: [],
      expandedIds: [],
      giacenzeMagazzino: [],
      giacenze_magazzino_backup: new Array(),
      headers: [
        {
          text: "Codice magazzino",
          value: "cod_magazzino",
        },
        {
          text: "Des. magazzino",
          value: "des_magazzino",
        },
        {
          text: "Cod. articolo",
          value: "cod_articolo",
        },
        {
          text: "Des. articolo",
          value: "des_articolo",
        },
        {
          text: "UM Gestione",
          value: "des_um",
        },
        {
          text: "Giacenza",
          value: "giacenza",
        },
        {
          text: "Impegno",
          value: "impegno",
        },
        {
          text: "Disponibilita",
          value: "disponibilita",
        },
        {
          text: "Movimenti",
          value: "movimenti",
          sortable: false,
        },
      ],
      headers_articoli: [
        {
          value: "modifica",
          text: "Scelta",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des. articolo",
          value: "des_articolo",
          sortable: false,
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
          sortable: false,
        },
        {
          text: "Numero d'Ordine",
          value: "des_aggiuntiva",
          sortable: false,
        },
      ],
      headers_lotti_nuovo_movimento: [
        {
          text: "Selezione",
          value: "selezione",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Cod. Lotto",
          value: "cod_lotto",
          sortable: false,
        },
        {
          text: "Data Scadenza",
          value: "data_scadenza",
          sortable: false,
        },
      ],
      headers_progetti: [
        { text: "Selezione", value: "seleziona", sortable: false },
        { text: "Des. Progetto", value: "des_progetto", sortable: false },
        { text: "Cod. Progetto", value: "codice", sortable: false },
      ],
      items_articoli: [],
      items_lotti_nuovo_movimento: new Array(),
      items_lotti_nuovo_movimento_visualizzati: new Array(),
      items_progetti: new Array(),
      items_progetti_visualizzati: new Array(),
      items_ricerche_selezionabili: new Array(),
      lista_tabella: [],
      magazzini: [],
      posizioniarticolo: [],
      subHeaders: [
        {
          text: "Confermato",
          value: "id_controllo",
        },
        {
          text: "Posizione",
          value: "path",
        },
        {
          text: "Data",
          value: "date_ins",
        },
        {
          text: "Data Scadenza",
          value: "data_scadenza_lotto",
        },
        {
          text: "Lotto",
          value: "cod_lotto",
        },
        {
          text: "Seriale",
          value: "numero_seriale",
        },
        {
          text: "Qta",
          value: "giacenza",
        },
        {
          text: "Ristampa",
          value: "ristampa",
        },
      ],
      ubicazioneTree: [],
      ubicazioni: [],
    };
  },
  watch: {
    codice_magazzino: {
      immediate: true,
      handler() {
        this.filtro();
      },
    },
    descrizione_magazzino: {
      immediate: true,
      handler() {
        this.filtro();
      },
    },
    filtro_progetti_cod: {
      immediate: true,
      handler() {
        this.filtraProgetti();
      },
    },
    filtro_progetti_des: {
      immediate: true,
      handler() {
        this.filtraProgetti();
      },
    },
    filtro_selezionato: {
      immediate: true,
      handler() {
        if (this.filtro_selezionato != null) {
          this.getRicerca();
        }
      },
    },
    sede: {
      immediate: true,
      handler() {
        this.filtro();
      },
    },
  },
  computed: {
    data_nuovo_lotto_formattata() {
      return this.nuovo_lotto.data_scadenza != ""
        ? moment(this.nuovo_lotto.data_scadenza).format("DD/MM/YYYY")
        : "";
    },
    sedi() {
      let sed = [];
      sed.push({ sede_magazzino: "Tutti" });
      this.giacenzeMagazzino.map((item) => sed.push(item));

      return sed;
    },
  },
  methods: {
    aggiungiLotto() {
      // Controllo che ci sia il codice lotto.
      if (
        this.nuovo_lotto.cod_lotto == null ||
        this.nuovo_lotto.cod_lotto == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Inserire il codice lotto.");
        return;
      }

      // Controllo che ci sia la data
      if (
        this.nuovo_lotto.data_scadenza == null ||
        this.nuovo_lotto.data_scadenza == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Inserire la data di scadenza.");
        return;
      }

      // Controllo che non ci sia già un lotto con lo stesso codice.
      if (
        this.items_lotti_nuovo_movimento.filter(
          (elem) => elem.cod_lotto == this.nuovo_lotto.cod_lotto
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Questo codice lotto esiste già per questo articolo."
        );
        return;
      }

      this.dialog_add_lotto = false;
      this.dialog_lotto_nuovo_movimento = false;
      this.tempMovimento.id_lotto = -1;
      this.tempMovimento.cod_lotto = this.nuovo_lotto.cod_lotto;
      this.tempMovimento.data_scadenza_lotto = this.nuovo_lotto.data_scadenza;
    },
    applicaFiltri(arg_arr) {
      if (arg_arr.length == 0) {
        return;
      }

      const arr_id_articolo = new Array();
      const arr_id_magazzino = new Array();
      const arr_cod_lotto = new Array();
      const arr_ubicazione = new Array();
      const arr_seriale = new Array();

      // Mi faccio la distinct degli id_articolo.
      arg_arr.forEach((a) => {
        if (
          arr_id_articolo.filter((e) => e == a.id_articolo).length == 0 &&
          a.id_articolo != null &&
          a.id_articolo != ""
        ) {
          arr_id_articolo.push(a.id_articolo);
        }
      });

      // Mi faccio la distinct degli id_magazzino.
      arg_arr.forEach((a) => {
        if (
          arr_id_magazzino.filter((e) => e == a.id_magazzino).length == 0 &&
          a.id_magazzino != null &&
          a.id_magazzino != ""
        ) {
          arr_id_magazzino.push(a.id_magazzino);
        }
      });

      // Mi faccio la distinct dei cod_lotto.
      arg_arr.forEach((a) => {
        if (
          arr_cod_lotto.filter((e) => e == `'${a.cod_lotto}'`).length == 0 &&
          a.cod_lotto != null &&
          a.cod_lotto != ""
        ) {
          arr_cod_lotto.push(`'${a.cod_lotto}'`);
        }
      });

      // Mi faccio la distinct di ubicazione.
      arg_arr.forEach((a) => {
        if (
          arr_ubicazione.filter((e) => e == `'${a.ubicazione}'`).length == 0 &&
          a.ubicazione != null &&
          a.ubicazione != ""
        ) {
          arr_ubicazione.push(`'${a.ubicazione}'`);
        }
      });

      // Mi faccio la distinct di seriale.
      arg_arr.forEach((a) => {
        if (
          arr_seriale.filter((e) => e == `'${a.seriale}'`).length == 0 &&
          a.seriale != null &&
          a.seriale != ""
        ) {
          arr_seriale.push(`'${a.seriale}'`);
        }
      });

      const str_filtro_id_articolo =
        arr_id_articolo.length > 0
          ? arr_id_articolo.toString().replace("[", "").replace("]", "")
          : "";
      const str_filtro_id_magazzino =
        arr_id_magazzino.length > 0
          ? arr_id_magazzino.toString().replace("[", "").replace("]", "")
          : "";
      const str_filtro_cod_lotto =
        arr_cod_lotto.length > 0
          ? arr_cod_lotto.toString().replace("[", "").replace("]", "")
          : "";
      const str_filtro_ubicazione =
        arr_ubicazione.length > 0
          ? arr_ubicazione.toString().replace("[", "").replace("]", "")
          : "";
      const str_filtro_seriale =
        arr_seriale.length > 0
          ? arr_seriale.toString().replace("[", "").replace("]", "")
          : "";

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlottimagazzini",
          token: localStorage.user_token,
          id_articolo: str_filtro_id_articolo,
          id_magazzino: str_filtro_id_magazzino,
          cod_lotto: str_filtro_cod_lotto,
          ubicazione: str_filtro_ubicazione,
          seriale: str_filtro_seriale,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.giacenzeMagazzino = [];

        res.data.articolo_magazzino.forEach((elem, i) => {
          elem.index = i;
          elem.lotti = res.data.lotti.filter(
            (el) =>
              el.id_magazzino == elem.id_magazzino &&
              el.id_articolo == elem.id_articolo
          );
          this.giacenzeMagazzino.push(elem);
        });

        this.lista_tabella = this.giacenzeMagazzino;
        this.loading = false;

        this.getimpegno();
      });
    },
    chiudiMovimentoDialog() {
      this.movimentoDialog = false;
      this.tempMovimento = {
        id_magazzino_movimenti: -1,
        id_magazzino: 0,
        id_ubicazione: 0,
        id_articolo: 0,
        cod_articolo: "",
        des_articolo: "",
        id_lotto: 0,
        cod_lotto: "",
        numero_seriale: "",
        quantita: 0,
        data_scadenza_lotto: "",
      };
      this.nuovo_lotto = { cod_lotto: "", data_scadenza: "" };
      this.tempUbicazione = {};
    },
    clickAggiungiLotto() {
      this.dialog_add_lotto = true;
      this.nuovo_lotto.cod_lotto = "";
      this.nuovo_lotto.data_scadenza = "";
    },
    async clickGestisciImpegniGenerali() {
      await this.getProgetti();
      this.dialog_selezione_progetti = true;
    },
    clickImpegnaSuProgetto() {
      // Controllo che sia stato selezionato un articolo.
      if (this.id_articolo_sel == null || this.id_articolo_sel == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare un articolo");
        return;
      }

      this.input_args.id_articolo = this.id_articolo_sel;
      this.input_args.landing_page = "/impegni";

      this.impegni_progetto_visible = true;
      this.key_impegno_articolo = this.key_impegno_articolo == 1 ? 0 : 1;
    },
    editLottoNuovoMovimento() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlottiarticolo",
          token: localStorage.user_token,
          id_articolo: this.tempArticolo.id_articolo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.items_lotti_nuovo_movimento = res.data;
            this.items_lotti_nuovo_movimento_visualizzati = res.data;
            this.dialog_lotto_nuovo_movimento = true;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    filtraLotti() {
      let items_lotti_nuovo_movimento_tmp = [];
      this.items_lotti_nuovo_movimento.forEach((elem) => {
        items_lotti_nuovo_movimento_tmp.push(elem);
      });

      // Filtro il codice lotto
      if (this.filter_cod_lotto != null && this.filter_cod_lotto != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_lotti_nuovo_movimento_tmp.forEach((elem) => {
          if (
            elem.cod_lotto
              .toUpperCase()
              .includes(this.filter_cod_lotto.toUpperCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_lotti_nuovo_movimento_tmp = res;
      }

      this.items_lotti_nuovo_movimento_visualizzati = [];
      this.items_lotti_nuovo_movimento_visualizzati =
        items_lotti_nuovo_movimento_tmp;
    },
    filtraProgetti() {
      let items_progetti_tmp = [];
      this.items_progetti.forEach((elem) => {
        items_progetti_tmp.push(elem);
      });

      // Filtro il codice progetto
      if (this.filtro_progetti_cod != null && this.filtro_progetti_cod != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_progetti_tmp.forEach((elem) => {
          if (
            elem.codice
              .toUpperCase()
              .includes(this.filtro_progetti_cod.toUpperCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_progetti_tmp = res;
      }

      // Filtro la descrizione progetto
      if (this.filtro_progetti_des != null && this.filtro_progetti_des != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_progetti_tmp.forEach((elem) => {
          if (
            elem.des_progetto
              .toUpperCase()
              .includes(this.filtro_progetti_des.toUpperCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_progetti_tmp = res;
      }

      this.items_progetti_visualizzati = [];
      this.items_progetti_visualizzati = items_progetti_tmp;
    },
    getModuli() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni sulle varianti, le registro.
            if (
              res.data.result.filter((e) => e.descrizione === "MODULO_VARIANTI")
                .length > 0 &&
              res.data.result.filter(
                (e) => e.descrizione === "MODULO_VARIANTI"
              )[0].val_int == 1
            ) {
              this.headers_articoli = [
                {
                  value: "modifica",
                  text: "Scelta",
                  sortable: false,
                },
                {
                  text: "Cod. Articolo",
                  value: "cod_articolo",
                  sortable: false,
                },
                {
                  text: "Des. articolo",
                  value: "des_articolo",
                  sortable: false,
                },
                {
                  text: "Variante",
                  value: "variante",
                  sortable: false,
                },
                {
                  text: "Famiglia",
                  value: "id_famiglia",
                  sortable: false,
                },
                {
                  text: "Numero d'Ordine",
                  value: "des_aggiuntiva",
                  sortable: false,
                },
              ];
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getProgetti() {
      const request = {
        controller: "contabilita",
        method: "POST",
        richiesta: {
          action: "getprogetti",
          token: localStorage.user_token,
        },
      };

      this.loading = true;
      return this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.items_progetti = res.data.result.progetti
              ? res.data.result.progetti
              : [];
            this.items_progetti.sort((a, b) =>
              (b.data_inizio ? b.data_inizio : "").localeCompare(
                a.data_inizio ? a.data_inizio : ""
              )
            );
            this.items_progetti_visualizzati = JSON.parse(
              JSON.stringify(this.items_progetti)
            );

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    RistampaReport(arg) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "ristampareport",
          id_magazzino_movimenti: arg.id_magazzino_movimenti,
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status == 200) {
            // Gestione delle snackbar di avviso di Alberto.
            if (
              "tipo_messaggio" in res.data &&
              "query_messaggio" in res.data &&
              res.data.tipo_messaggio == 1
            ) {
              this.$refs.SnackbarQV.print("orange", res.data.query_messaggio);
            }

            // Logica di business.
            const byteCharacters = atob(res.data.result.result);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);
            this.selected_pdf = blobUrl;
            this.pdfdialog = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Impossibile generare la stampa."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          if (
            "tipo_messaggio" in err.response.data &&
            "query_messaggio" in err.response.data &&
            err.response.data.tipo_messaggio == 2
          ) {
            this.$refs.SnackbarQV.print(
              "error",
              err.response.data.query_messaggio
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Impossibile generare la stampa."
            );
          }
          return false;
        });
    },
    selezionaLotto(arg) {
      this.tempMovimento.id_lotto = arg.id_lotto;
      this.tempMovimento.cod_lotto = arg.cod_lotto;
      this.nuovo_lotto.data_scadenza = `${arg.data_scadenza.substring(
        6,
        10
      )}-${arg.data_scadenza.substring(3, 5)}-${arg.data_scadenza.substring(
        0,
        2
      )}`;
      this.tempMovimento.data_scadenza_lotto = this.nuovo_lotto.data_scadenza;
      this.dialog_lotto_nuovo_movimento = false;
    },
    selezionaProgetto(arg) {
      this.dialog_selezione_progetti = false;
      this.input_args.id_progetto = arg.id_progetto;
      this.input_args.landing_page = "/impegniprogetto";
      this.impegni_totali_progetto = true;
      this.key_impegni_generali = this.key_impegni_generali == 0 ? 1 : 0;
    },
    cancellaFiltri() {
      this.data_start = null;
      this.data_start_formatted = null;
      this.data_end = null;
      this.data_end_formatted = null;
      this.codice_articolo = null;
      this.filtro_des_articolo = null;
      this.codice_lotto = null;
      this.codUbicazione = null;
      this.seriale = null;
      this.sede = null;
      this.codice_magazzino = null;
      this.descrizione_magazzino = null;
    },
    changeDate() {
      if (this.data_start != null) {
        this.data_start_formatted = this.data_start.toString();
      }
      if (this.data_end != null) {
        this.data_end_formatted = this.data_end.toString();
      }
      this.menu_da = false;
      this.menu_a = false;
    },
    clearEnd() {
      this.data_end_formatted = null;
      this.data_end = null;
      this.changeFilters();
    },
    clearStart() {
      this.data_start_formatted = null;
      this.data_start = null;
      this.changeFilters();
    },
    filtro() {
      this.lista_tabella = JSON.parse(JSON.stringify(this.giacenzeMagazzino));

      if (this.sede != null && this.sede != "Tutti") {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return el.sede_magazzino == this.sede;
        });
      }

      if (this.codice_magazzino != null && this.codice_magazzino != "Tutti") {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return el.cod_magazzino == this.codice_magazzino;
        });
      }

      if (
        this.descrizione_magazzino != null &&
        this.descrizione_magazzino != "Tutti"
      ) {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return el.des_magazzino == this.descrizione_magazzino;
        });
      }
    },
    handleImpegniSalvati() {
      this.impegni_progetto_visible = false;
      this.$refs.SnackbarQV.print("success", "L'impegno è stato registrato.");
    },
    toggleFilters() {
      this.show_filters = !this.show_filters;
    },
    updateUbicazione() {
      this.tempUbicazione.des_dettaglio = this.selMagazzino.des_magazzino;
      this.tempUbicazione.id_magazzino = this.selMagazzino.id_magazzino;
      this.ubicazioneDialog = false;
    },
    vistaSintetica() {
      this.expandedIds = [];
    },
    vistaDettagliata() {
      this.expandedIds = this.giacenzeMagazzino;
    },
    chiudiMultiscelta() {
      this.dialog_multiscelta = false;
    },
    clickScegliArticolo(arg) {
      this.tempArticolo = Object.assign({}, arg);
      this.getposizioni();
      this.codice_articolo = arg.cod_articolo;
      this.filtro_des_articolo = arg.des_articolo;
      this.id_articolo_sel = arg.id_articolo;
      this.articolo_gestione_lotti = arg.gestione_lotto;

      // Chiudo il dialog di scelta.
      this.dialog_multiscelta = false;

      this.loading = true;
      this.getArticoloMagazzini();
    },
    getposizioni(arg_id_magazzino = "") {
      this.loading = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getposizioniarticolo",
          id_articolo: this.tempArticolo.id_articolo,
          token: localStorage.user_token,
          id_magazzino: arg_id_magazzino,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        this.posizioniarticolo = Array.from(res.data.result.posizioni);
        this.loading = false;
      });
    },
    searchAllInMagazzino() {
      // Controllo di avere un codice magazzino.
      if (
        this.codice_magazzino != null &&
        this.codice_magazzino != "" &&
        this.codice_magazzino == "Tutti" &&
        this.descrizione_magazzino != null &&
        this.descrizione_magazzino != "" &&
        this.descrizione_magazzino == "Tutti"
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare un codice magazzino."
        );
        return;
      }

      // Controllo che non ci sia un codice articolo o una descrizione articolo.
      if (
        (this.codice_articolo != null && this.codice_articolo != "") ||
        (this.filtro_des_articolo != null && this.filtro_des_articolo != "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il codice articolo e la descrizione devono essere vuoti per eseguire questa ricerca."
        );
        return;
      }

      /* Resetto l'id_articolo_sel e il tempArticolo perché
       * altrimenti ho dei problemi con le chiamate successive. */
      this.id_articolo_sel = null;
      this.tempArticolo = new Object();

      const id_magazzino_tmp = this.giacenze_magazzino_backup.filter(
        (e) =>
          e.cod_magazzino == this.codice_magazzino ||
          e.des_magazzino == this.descrizione_magazzino
      )[0].rif_magazzino;

      this.getArticoloMagazzini(id_magazzino_tmp);
    },
    searchByCodDesArticolo() {
      // Se non ho dato codice né descrizione né magazzino, fermo tutto.
      if (
        (this.codice_articolo === "" || this.codice_articolo === null) &&
        (this.filtro_des_articolo === "" ||
          this.filtro_des_articolo === null) &&
        (this.codice_magazzino == "" ||
          this.codice_magazzino == null ||
          this.codice_magazzino == "Tutti") &&
        (this.descrizione_magazzino == "" ||
          this.descrizione_magazzino == null ||
          this.descrizione_magazzino == "Tutti")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare codice / descrizione articolo."
        );
        return;
      }

      this.loading = true;

      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: this.codice_articolo,
        },
      };

      if (this.filtro_des_articolo != null && this.filtro_des_articolo !== "") {
        search_Articolo.richiesta.des_articolo = this.filtro_des_articolo;
      }

      // Eseguo la chiamata al BE
      this.$store
        .dispatch("api", search_Articolo)
        .then((res) => {
          this.loading = false;

          if (res.status === 200) {
            // Se non ci sono risultati stampo una snackbar di avviso.
            if (res.data.lista.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                `Non sono stati trovati articoli corrispondenti ai criteri di ricerca.`
              );
            } else if (res.data.lista.length === 1) {
              this.id_articolo_sel = res.data.lista[0].id_articolo;
              this.filtro_des_articolo = res.data.lista[0].des_articolo;
              this.articolo_gestione_lotti = res.data.lista[0].gestione_lotto;
              this.getArticoloMagazzini();
              this.tempArticolo = Object.assign({}, res.data.lista[0]);
              this.getposizioni();
            } else {
              /* Se ci sono più risultati li carico in una tabella e
               * apro il dialog di scelta dell'articolo. */
              this.items_articoli = Array.from(res.data.lista);
              this.dialog_multiscelta = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Criticità rilevata, non è stato possibile caricare i dati; codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    searchCodUbicazione() {
      if (this.codUbicazione === "" || this.codUbicazione === null) {
        this.$refs.SnackbarQV.print("orange", "Specificare un ubicazione.");
      } else {
        this.loading = true;

        this.getArticoloMagazziniByLotto();
      }
    },
    searchBySeriale() {
      if (this.seriale === "" || this.seriale === null) {
        this.$refs.SnackbarQV.print("orange", "Specificare un seriale.");
      } else {
        this.loading = true;

        this.getArticoloMagazziniByLotto();
      }
    },
    searchByDate() {
      if (
        (this.data_start_formatted === "" ||
          this.data_start_formatted === null) &&
        (this.data_end_formatted === "" || this.data_end_formatted === null)
      ) {
        this.$refs.SnackbarQV.print("orange", "Specificare almeno una data");
      } else {
        this.loading = true;

        this.getArticoloMagazziniByLotto();
      }
    },
    searchByCodiceParziale() {
      if (this.codice_articolo == "" || this.codice_articolo == null) {
        this.$refs.SnackbarQV.print("error", "Specificare un codice articolo.");
        return;
      }

      this.loading = true;

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlottimagazzini",
          token: localStorage.user_token,
          cod_articolo: this.codice_articolo.replaceAll("*", "%"),
          cod_lotto:
            this.codice_lotto != null && this.codice_lotto != ""
              ? `'${this.codice_lotto}'`
              : null,
          ubicazione:
            this.codUbicazione != null && this.codUbicazione != ""
              ? `'${this.codUbicazione}'`
              : null,
          seriale:
            this.seriale != null && this.seriale != ""
              ? `'${this.seriale}'`
              : null,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.giacenzeMagazzino = [];

        res.data.articolo_magazzino.forEach((elem, i) => {
          elem.index = i;
          elem.lotti = res.data.lotti.filter(
            (el) =>
              el.id_magazzino == elem.id_magazzino &&
              el.id_articolo == elem.id_articolo
          );
          this.giacenzeMagazzino.push(elem);
        });

        this.lista_tabella = this.giacenzeMagazzino;
        this.loading = false;
      });
    },
    searchByCodiceLotto() {
      if (this.codice_lotto === "" || this.codice_lotto === null) {
        this.$refs.SnackbarQV.print("orange", "Specificare un codice lotto.");
      } else {
        this.loading = true;

        this.getArticoloMagazziniByLotto();
      }
    },
    async nuovoMovimento() {
      if (
        this.tempArticolo.cod_articolo == null ||
        this.tempArticolo.cod_articolo == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare un articolo prima di generare un nuovo movimento."
        );
        return;
      }

      // Se non ci sono ancora le causali, le prendo dal BE.
      if (this.causali.length == 0) {
        await this.getCausali();
      }

      // Se ci sono vausali con val_int valorizzato...
      if (
        this.causali.filter(
          (elem) => elem.val_int != null && elem.val_int != ""
        ).length > 0
      ) {
        //* Cerco la causale di Prod WIP se c'è.
        if (this.causali.filter((elem) => elem.cod == "PRODWIP").length > 0) {
          this.tempMovimento.id_causale = this.causali.filter(
            (elem) => elem.cod == "PRODWIP"
          )[0].id_tabella;
        } else if (this.causali.length > 0) {
          /* Se non c'è una causale di Prod WIP prendo come
           * dato di default la prima causale che capita . */
          this.tempMovimento.id_causale = this.causali[0].id_tabella;
        }
      }

      // Se non ci sono ancora magazzini, li prendo dal BE.
      if (this.magazzini.length == 0) {
        await this.selectUbicazione(0);
      }

      /* Se l'articolo ha un magazzino di riferimento e se ho un
       * magazzino che gli corrisponde, seleziono quel magazzino. */
      if (
        this.tempArticolo.id_magazzino != null &&
        this.tempArticolo.id_magazzino != "" &&
        this.magazzini.filter(
          (elem) => elem.id_magazzino == this.tempArticolo.id_magazzino
        ).length > 0
      ) {
        this.selMagazzino = JSON.parse(
          JSON.stringify(
            this.magazzini.filter(
              (elem) => elem.id_magazzino == this.tempArticolo.id_magazzino
            )[0]
          )
        );

        this.updateUbicazione();
      }

      this.movimentoDialog = true;
    },
    salvaMovimento() {
      // Controllo che ci sia un'ubicazione.
      if (
        this.tempUbicazione.des_dettaglio == null ||
        this.tempArticolo.cod_articolo == null ||
        this.tempUbicazione.des_dettaglio == "" ||
        this.tempArticolo.cod_articolo == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un'ubicazione.");
        return;
      }

      // Controllo che ci sia una causale.
      if (
        this.tempMovimento.id_causale == null ||
        this.tempMovimento.id_causale == ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare una causale.");
        return;
      }

      if (
        (this.tempMovimento.id_lotto == null ||
          this.tempMovimento.id_lotto == "" ||
          this.tempMovimento.cod_lotto == null ||
          this.tempMovimento.cod_lotto == "") &&
        this.articolo_gestione_lotti === 1
      ) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un lotto valido.");
        return;
      }

      /*if (
        this.tempMovimento.data_scadenza_lotto == null ||
        this.tempMovimento.data_scadenza_lotto == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare una data scadenza per il lotto."
        );
        return;
      }*/

      if (
        this.tempMovimento.quantita == 0 ||
        this.tempMovimento.quantita == null ||
        this.tempMovimento.quantita == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare una quantità (positiva o negativa) non nulla."
        );
        return;
      }

      this.loading = true;
      this.qntFinal =
        parseInt(this.tempUbicazione.quantita_att) +
        parseInt(this.tempMovimento.quantita);
      this.tempMovimento.data = moment().format("YYYY-MM-DD hh:mm:ss");
      this.tempMovimento.id_articolo = this.tempArticolo.id_articolo;
      this.tempMovimento.cod_articolo = this.tempArticolo.cod_articolo;
      this.tempMovimento.des_articolo = this.tempArticolo.des_articolo;
      this.tempMovimento.id_magazzino = this.tempUbicazione.id_magazzino;
      this.tempMovimento.id_ubicazione = this.tempUbicazione
        .id_magazzino_ubicazione
        ? this.tempUbicazione.id_magazzino_ubicazione
        : null;
      this.tempMovimento.id_causale_magazzino = 1;
      this.qntError = false;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmovimentimagazzino",
          movimento: [this.tempMovimento],
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status == 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Movimento salvato con successo"
            );
            this.loading = false;
            this.movimentoDialog = false;

            this.tempMovimento = {
              id_causale: null,
              id_causale_magazzino: 1,
              id_magazzino_movimenti: -1,
              id_magazzino: 0,
              id_ubicazione: 0,
              id_articolo: 0,
              cod_articolo: "",
              des_articolo: "",
              id_lotto: 0,
              cod_lotto: "",
              numero_seriale: "",
              quantita: 0,
              data_scadenza_lotto: "",
            };
            //this.tempArticolo = {};
            this.tempUbicazione = {};
            this.nuovo_lotto = { cod_lotto: "", data_scadenza: "" };

            this.searchByCodDesArticolo();
          } else {
            this.$refs.SnackbarQV.print("error", "Movimento non salvato");
            this.loading = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazion col server."
          );
        });
    },
    getCausali() {
      this.loading = true;

      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          tipo: "CAUSALI_MAGAZZINO_MOVIMENTI",
          token: localStorage.user_token,
        },
      };

      return this.$store.dispatch("api", request).then(async (res) => {
        this.causali = Array.from(res.data);
        this.loading = false;
        return true;
      });
    },
    getMagazziniAll() {
      this.loading = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.giacenze_magazzino_backup = Array.from(res.data);
            this.giacenze_magazzino_backup.forEach((e) => {
              e.cod_des_magazzino = `${e.cod_magazzino} - ${e.des_magazzino}`;
            });
            this.giacenze_magazzino_backup.unshift({
              id_magazzino: null,
              cod_magazzino: "Tutti",
              des_magazzino: "Tutti",
              cod_des_magazzino: "Tutti",
            });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
            return false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server."
          );
          return false;
        });
    },
    selectItem(item) {
      if (this.ubicazioneSelectMode == 0) {
        this.tempUbicazione = Object.assign({}, item);
        this.tempUbicazione.quantita_att = 0;
        for (let i = 0; i < this.posizioniarticolo.length; i++) {
          const e = this.posizioniarticolo[i];
          if (e.id_ubicazione == this.tempUbicazione.id_magazzino_ubicazione) {
            this.tempUbicazione.quantita_att += e.quantita;
          }
        }
      } else {
        this.loading = true;
        this.searchUbicazione = Object.assign({}, item);
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getlottimagazzini",
            token: localStorage.user_token,
            id_articolo: this.id_articolo_sel,
            cod_lotto:
              this.codice_lotto != null && this.codice_lotto != ""
                ? `'${this.codice_lotto}'`
                : null,
            ubicazione:
              this.codUbicazione != null && this.codUbicazione != ""
                ? `'${this.codUbicazione}'`
                : null,
            seriale:
              this.seriale != null && this.seriale != ""
                ? `'${this.seriale}'`
                : null,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          this.giacenzeMagazzino = [];
          res.data.articolo_magazzino.forEach((elem, i) => {
            elem.index = i;
            elem.lotti = res.data.lotti.filter(
              (el) =>
                el.id_magazzino == elem.id_magazzino &&
                el.id_articolo == elem.id_articolo
            );
            this.giacenzeMagazzino.push(elem);
          });
          this.lista_tabella = this.giacenzeMagazzino;
          this.getimpegno();
          this.loading = false;
        });
      }

      this.ubicazioneDialog = false;
    },
    searchSelectUbicazione() {
      this.ubicazioneSelectMode = 1;
      this.selectUbicazione();
    },
    movimentoSelectUbicazione() {
      this.ubicazioneSelectMode = 0;
      this.selectUbicazione();
    },
    selectUbicazione(arg_dialog = 1) {
      this.loading = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.magazzini = Array.from(res.data);
            this.selMagazzino = null;
            this.ubicazioneTree = [];
            if (arg_dialog == 1) {
              this.ubicazioneDialog = true;
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
            return false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server."
          );
          return false;
        });
    },
    fixtree(arg) {
      try {
        arg.forEach((e) => {
          e.children = null;
          Object.keys(e).forEach((k) => {
            if (k.includes("dettaglio") && !k.includes("_")) {
              e.children = e[k];
            }
          });
          e.name = e.des_dettaglio;
          this.fixtree(e.children);
        });
      } catch (error) {
        return;
      }
    },
    getRicerca() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getricerca",
          token: localStorage.user_token,
          id_ricerca: this.filtro_selezionato,
        },
      };

      this.loading = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.ricerca_sel = {
              des_ricerca: "Default",
              query: this.items_ricerche_selezionabili.filter(
                (r) => r.id_ricerca == this.filtro_selezionato
              )[0].query,
              id_ricerca: this.filtro_selezionato,
              filtri_dettaglio: res.data.result.ricerca_dettaglio,
              struttura_logica: this.items_ricerche_selezionabili.filter(
                (e) => e.id_ricerca == this.filtro_selezionato
              )[0].struttura_logica,
            };
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getRicerche() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getricercheselezionabili",
          token: localStorage.user_token,
          modulo: this.modulo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_ricerche_selezionabili = res.data.result.ricerche;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getStruttura(arg) {
      this.loading = true;
      var request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzinoubicazione",
          token: localStorage.user_token,
          id_utente: localStorage.id,
          id_magazzino: arg.id_magazzino,
        },
      };

      this.$store.dispatch("api", request).then(async (res) => {
        if (res.status == 200) {
          this.ubicazioneTree = Array.from(res.data.dettaglio0);
          this.fixtree(this.ubicazioneTree);
          this.$forceUpdate();
          this.loading = false;
        }
      });
    },
    getimpegno() {
      // Registro gli articoli da cercare in base a quello che c'è nella lista.
      var articoli = [];

      this.lista_tabella.forEach((e) => {
        // Se non l'ho già registrato, lo registro ora.
        if (
          articoli.filter((a) => a.id_articolo == e.id_articolo).length == 0
        ) {
          articoli.push({ id_articolo: e.id_articolo });
        }
      });

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoloimpegno",
          articoli: articoli,
          token: localStorage.user_token,
        },
      };

      if (this.loading == false) {
        this.loading = true;
      }

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          var impegno = 0;
          this.lista_tabella.forEach((e) => {
            impegno = 0;
            res.data.result[e.id_articolo.toString()].forEach((e2) => {
              if (e.id_magazzino == e2.id_magazzino) {
                impegno += e2.qnt_impegno;
              }
            });
            e.impegno = impegno;
            e.disponibilita = e.giacenza - e.impegno;
          });
          this.tableKey++;
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "orange",
            "Si è verificato un errore nel caricamento delle giacenze."
          );
        });
    },
    getArticoloMagazzini(arg_id_magazzino = "") {
      var request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlottimagazzini",
          token: localStorage.user_token,
          id_articolo: this.id_articolo_sel,
          cod_lotto:
            this.codice_lotto != null && this.codice_lotto != ""
              ? `'${this.codice_lotto}'`
              : null,
          ubicazione:
            this.codUbicazione != null && this.codUbicazione != ""
              ? `'${this.codUbicazione}'`
              : null,
          seriale:
            this.seriale != null && this.seriale != ""
              ? `'${this.seriale}'`
              : null,
        },
      };

      if (arg_id_magazzino != "" && arg_id_magazzino != null) {
        request.richiesta.id_magazzino = arg_id_magazzino;
      }

      if (this.loading == false) {
        this.loading = true;
      }

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.loading = false;
          this.giacenzeMagazzino = [];

          res.data.articolo_magazzino
            .filter((elem) => elem.id_articolo != null)
            .forEach((elem, i) => {
              elem.index = i;
              elem.lotti = res.data.lotti.filter(
                (el) =>
                  el.id_magazzino == elem.id_magazzino &&
                  el.id_articolo == elem.id_articolo
              );
              this.giacenzeMagazzino.push(elem);
            });

          this.lista_tabella = JSON.parse(
            JSON.stringify(this.giacenzeMagazzino)
          );

          this.getimpegno();
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "orange",
            "Si è verificato un errore nel caricamento delle giacenze."
          );
        });
    },
    redirectToMagazzinoMovimenti(item) {
      // Eseguo il redirect della pagina.
      this.$router.push({
        name: "movimenti-magazzino",
        params: {
          id_magazzino: item.id_magazzino,
          id_articolo: item.id_articolo,
        },
      });

      /* Registro l'ultimo filtro speciale o cod_articolo o cod_magazzino
       * cercato in modo da essere più comodo quando dalla pagina delle
       * giacenze torno indietro e voglio vedere la mia ultima ricerca. */
      if (this.filtro_selezionato != null) {
        this.$store.ultimo_filtro_selezionato = JSON.parse(
          JSON.stringify(this.filtro_selezionato)
        );
        this.$store.ultima_ricerca_selezionata = JSON.parse(
          JSON.stringify(this.ricerca_sel)
        );
      } else if (this.codice_articolo != null && this.codice_articolo != "") {
        this.$store.ultimo_cod_articolo_cercato = this.codice_articolo;
      } else if (this.codice_magazzino != null && this.codice_magazzino != "") {
        this.$store.ultimo_cod_magazzino_cercato = this.codice_magazzino;
        this.$store.ultime_giacenze_magazzino_backup = JSON.parse(
          JSON.stringify(this.giacenze_magazzino_backup)
        );
      } else if (
        this.descrizione_magazzino != null &&
        this.descrizione_magazzino != ""
      ) {
        this.$store.ultima_des_magazzino_cercata = this.descrizione_magazzino;
        this.$store.ultime_giacenze_magazzino_backup = JSON.parse(
          JSON.stringify(this.giacenze_magazzino_backup)
        );
      }
    },
    getArticoloMagazziniByLotto() {
      var request = {};
      request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlottimagazzini",
          token: localStorage.user_token,
          id_articolo:
            this.codice_articolo != "" && this.codice_articolo != null
              ? this.id_articolo_sel
              : null,
          cod_lotto:
            this.codice_lotto != null && this.codice_lotto != ""
              ? `'${this.codice_lotto}'`
              : null,
          ubicazione:
            this.codUbicazione != null && this.codUbicazione != ""
              ? `'${this.codUbicazione}'`
              : null,
          seriale:
            this.seriale != null && this.seriale != ""
              ? `'${this.seriale}'`
              : null,
          data_da: this.data_start_formatted,
          data_a: this.data_end_formatted,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.giacenzeMagazzino = [];

        res.data.articolo_magazzino.forEach((elem, i) => {
          elem.index = i;
          elem.lotti = res.data.lotti.filter(
            (el) =>
              el.id_magazzino == elem.id_magazzino &&
              el.id_articolo == elem.id_articolo
          );
          this.giacenzeMagazzino.push(elem);
        });

        this.lista_tabella = this.giacenzeMagazzino;
        this.loading = false;
      });
    },
  },
  async mounted() {
    this.id_utente = localStorage.id;
    this.id_profilo = localStorage.id_profilo;
    this.getRicerche();

    /* Verifico se ci sono le varianti dell'articolo
     * e se ci sono modifico gli headers di scelta
     * del cod_articolo di conseguenza. */
    this.getModuli();

    // Verifico se ci sono ricerche da ripristinare.
    if (this.$store.ultimo_filtro_selezionato) {
      this.filtro_selezionato = this.$store.ultimo_filtro_selezionato;
      this.ricerca_sel = this.$store.ultima_ricerca_selezionata;
      delete this.$store.ultimo_filtro_selezionato;
      delete this.$store.ultima_ricerca_selezionata;
    } else if (this.$store.ultimo_cod_articolo_cercato) {
      // Se ho appena cercato un articolo, ripristino l'ultima ricerca.
      this.codice_articolo = this.$store.ultimo_cod_articolo_cercato;

      this.searchByCodDesArticolo();
      delete this.$store.ultimo_cod_articolo_cercato;
    } else if (this.$store.ultimo_cod_magazzino_cercato) {
      /* Se ho appena cercato tutti gli articoli di un
       * magazzino, ripristino l'ultima ricerca. */
      await this.getMagazziniAll();
      this.giacenze_magazzino_backup =
        this.$store.ultime_giacenze_magazzino_backup;
      this.codice_magazzino = this.$store.ultimo_cod_magazzino_cercato;
      this.searchAllInMagazzino();
      delete this.$store.ultimo_cod_magazzino_cercato;
      delete this.$store.ultime_giacenze_magazzino_backup;
    } else if (this.$store.ultima_des_magazzino_cercata) {
      this.descrizione_magazzino = this.$store.ultima_des_magazzino_cercata;
      this.giacenze_magazzino_backup =
        this.$store.ultime_giacenze_magazzino_backup;
      this.searchAllInMagazzino();
      delete this.$store.ultima_des_magazzino_cercata;
      delete this.$store.ultime_giacenze_magazzino_backup;
    } else {
      /* Altrimenti cerco tutti i magazzini esistenti così se l'utente
       * vuole vedere tutte le giacenze di un magazzino indipendentemente
       * dall'articolo, lo può selezionare. */
      this.getMagazziniAll();
    }
  },
};
</script>